import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Location.module.scss";

export type LocationProps = PlatformComponentProps & {
  city: string;
};

export const Location = ({ city, className }: LocationProps) => {
  const styles = useHotelsStyles(
    CoreHotelsComponent.HotelCardLocation,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    CoreHotelsComponent.HotelCardLocation
  );

  if (city === "") {
    return null;
  }

  return (
    <div className={clsx(block, className)}>
      <Icon iconName={IconNameEnum.mapPin} /> {city}
    </div>
  );
};
